import { withAuthGate } from '@sunrise-ui/composites';
import ConversationView from '@templates/ConversationView';
import React from 'react';

function ConversationScreen() {
  return <ConversationView />;
}

export default withAuthGate(ConversationScreen);
